function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { format, parseISO, isValid, parse, isBefore, getDaysInMonth, startOfMonth, getDay, endOfMonth, setDate, startOfWeek, addDays, isSameDay, isToday, addMonths, isSameMonth, subMonths, addWeeks, addYears, endOfWeek, subDays, subWeeks, subYears } from 'date-fns';
import { chunk } from "./array.js";

/**
 * Add a day to a date.
 *
 * @param date Date
 * @returns Date
 */
var addDay = function addDay(date) {
  return addDays(date, 1);
};
/**
 * Add a month to a date.
 *
 * @param date Date
 * @returns Date
 */
var addMonth = function addMonth(date) {
  return addMonths(date, 1);
};
/**
 * Add a week to a date.
 *
 * @param date Date
 * @returns Date
 */
var addWeek = function addWeek(date) {
  return addWeeks(date, 1);
};
/**
 * Add a year to a date.
 *
 * @param date Date
 * @returns Date
 */
var addYear = function addYear(date) {
  return addYears(date, 1);
};
/**
 *
 * @param date Date
 * @param other Date
 * @returns boolean
 */
var beforeDate = function beforeDate(date, other) {
  return isBefore(date, other);
};
/**
 * Convert a maybe date to a date.
 * Returns null if the date is invalid.
 *
 * @param date MaybeDate
 * @returns Date | null
 */
var convertToDate = function convertToDate(date, inputFormat) {
  if (!date) return null;
  if (typeof date === 'string' && validIso(date)) {
    var parsedIsoDate = parseISO(date);
    if (validDate(parsedIsoDate)) {
      return parsedIsoDate;
    }
  }
  if (typeof date === 'string' && validDate(date, inputFormat)) {
    return new Date(date);
  }
  if (typeof date === 'number' && validDate(date)) {
    return new Date(date);
  }
  if (date instanceof Date && validDate(date)) {
    return date;
  }
  return null;
};
/**
 * Get the end of the week for a date
 *
 * @param date Date
 * @returns Date
 */
var endWeek = function endWeek(date) {
  return endOfWeek(date);
};
/**
 * Format a date
 *
 * @param date Date
 * @param _format string
 * @param locale Locale
 * @returns Date
 */
var formatDate = function formatDate(date, _format, locale) {
  return format(date, _format, {
    locale: locale
  });
};
/**
 * Generate a calendar of 7 days in a week.
 * Null represents the days that are not in the current month.
 *
 * @param date Date
 * @returns (Date | null)[][]
 */
var generateCalendar = function generateCalendar(date) {
  var daysInMonth = getDaysInMonth(date);
  var startDateOfCurrentMonth = startOfMonth(date);
  var startWeekday = getDay(startDateOfCurrentMonth);
  var endDateOfCurrentMonth = endOfMonth(date);
  var endWeekday = getDay(endDateOfCurrentMonth);
  var gridDays = chunk([].concat(_toConsumableArray(Array.from({
    length: startWeekday
  }, function () {
    return null;
  })), _toConsumableArray(Array.from({
    length: daysInMonth
  }, function (_, i) {
    return setDate(date, i + 1);
  })), _toConsumableArray(Array.from({
    length: 6 - endWeekday
  }, function () {
    return null;
  }))), 7);
  return gridDays;
};
/**
 * Generate day of the week columns names and abbreviations.
 *
 * @param date Date
 * @param locale Locale
 * @returns DatePickerColumn[]
 */
var generateColumns = function generateColumns(date, locale) {
  var start = startOfWeek(date);
  return Array.from({
    length: 7
  }).fill(null).map(function (_, i) {
    return {
      abbr: format(addDays(start, i), 'EEEEEE', {
        locale: locale
      }),
      title: format(addDays(start, i), 'EEEE', {
        locale: locale
      })
    };
  });
};
/**
 * Get whether two dates are in the same day.
 *
 * @param date Date
 * @param other Date
 * @returns boolean
 */
var sameDay = function sameDay(date, other) {
  return isSameDay(date, other);
};
/**
 * Get whether two dates are in the same month.
 *
 * @param date Date
 * @param other Date
 * @returns boolean
 */
var sameMonth = function sameMonth(date, other) {
  return isSameMonth(date, other);
};
/**
 * Get the start of the week for a date.
 *
 * @param date Date
 * @returns Date
 */
var startWeek = function startWeek(date) {
  return startOfWeek(date);
};
/**
 * Subtract a day from a date.
 *
 * @param date Date
 * @returns Date
 */
var subDay = function subDay(date) {
  return subDays(date, 1);
};
/**
 * Subtract a month from a date.
 *
 * @param date Date
 * @returns Date
 */
var subMonth = function subMonth(date) {
  return subMonths(date, 1);
};
/**
 * Subtract a week from a date.
 *
 * @param date Date
 * @returns Date
 */
var subWeek = function subWeek(date) {
  return subWeeks(date, 1);
};
/**
 * Subtract a year from a date.
 *
 * @param date Date
 * @returns Date
 */
var subYear = function subYear(date) {
  return subYears(date, 1);
};
/**
 * Get whether a date is today.
 *
 * @param date Date
 * @returns Date
 */
var todayDate = function todayDate(date) {
  return isToday(date);
};
/**
 * Get whether a date is valid. Handles both date objects and ISO-like date strings.
 *
 * @param date unknown
 * @returns boolean
 */
var validDate = function validDate(date, inputFormat) {
  if (!date) return false;
  if (typeof date === 'string' && validIso(date)) return isValid(parseISO(date));
  if (typeof date === 'string' && inputFormat) return isValid(parse(date, inputFormat, new Date()));
  return isValid(date);
};
/**
 * Get whether a string is an ISO-like date (such as 2021-06-30 or 2021-06-30T00:00:00Z).
 * NOTE: This is not a comprehensive check and it doesn't validate the date itself.
 *
 * @param date string | null | undefined
 * @returns boolean
 */
var validIso = function validIso(date) {
  if (!date) return false;
  return date.split('-').length === 3;
};
/**
 * Validates a date object or date string.
 * If valid, returns valid as true as well as a date object, ISO-like date, and a formatted date value.
 * if invalid, returns valid as false.
 *
 * @param inputFormat DateInputFormats
 * @param maybeDate MaybeDate
 * @returns ValidatedDate
 */
var validateDate = function validateDate(inputFormat, maybeDate) {
  var response = {
    date: new Date(),
    dateIso: '',
    dateValue: '',
    valid: true
  };
  if (maybeDate && validDate(maybeDate, inputFormat)) {
    var date = convertToDate(maybeDate, inputFormat);
    if (date) {
      var dateIso = format(date, 'yyyy-MM-dd');
      var dateValue = format(date, inputFormat);
      return _objectSpread(_objectSpread({}, response), {}, {
        date: date,
        dateIso: dateIso,
        dateValue: dateValue
      });
    }
  }
  return _objectSpread(_objectSpread({}, response), {}, {
    valid: false
  });
};
export { addDay, addMonth, addWeek, addYear, beforeDate, convertToDate, endWeek, formatDate, generateCalendar, generateColumns, sameDay, sameMonth, startWeek, subDay, subMonth, subWeek, subYear, todayDate, validDate, validIso, validateDate };